<div class="cell">
    <div class="active">{{project?.name}}</div>

    <div>{{project?.companyName}}</div>
</div>

<div class="cell">
    <span #DeviceAmountAnchor
          [ngClass]="project?.requestedProductsTotalCount > 0  && project?.devices?.length ? 'active':''"
          (mouseenter)="onDeviceAmountMouseEnter(DeviceAmountAnchor)"
          (mouseleave)="onDeviceAmountMouseLeave()">
        {{project?.requestedProductsTotalCount}}
    </span>
</div>

<div class="cell">
    <span [ngClass]="{'highlighted': displayHighlighted( project )}">
        {{project?.quoteClosingDate| date:'dd.MM.yy' }}
    </span>
</div>

<div class="cell">
    <span>{{project?.rolloutStart | date:'dd.MM.yy' }} - {{project?.rolloutEnd | date:'dd.MM.yy'  }}</span>
</div>

<div class="cell">
    <span>{{project?.kam}}</span>
</div>

<div class="cell">
    <span>{{project?.lastUpdateBy}}</span>
</div>

<div class="cell max-condition-cell">
    <div class="max-condition" [ngClass]="{'project-table-btn': displayAsBtn(project)}">
        <span>{{getMaxConditionBtnLabel(project?.maxCondition)}}</span>
    </div>
</div>

<div class="cell" *ngIf="isProcessedModeUsed">
    <div class="project-table-btn" #StatusAnchor
         [ngClass]="{'rejected': priceApprovalStatusEnum[project.priceApprovalStatus] === priceApprovalStatusEnum.PRICES_REJECTED} "
         (mouseenter)="onStatusInfoMouseEnter(StatusAnchor, project)"
         (mouseleave)="onStatusInfoMouseLeave()">
        {{getStatusDetailText(project.priceApprovalStatus)}}
    </div>
</div>


<div class="cell actions active" (mouseleave)="setCloseMenuTimer()" (mouseenter)="removeCloseMenuTimer()">

    <button type="button" class="button invisible-button no-focus" (click)="onActionsBtnClicked()">
        <bd-fa-button class="button" [name]="'cog'">
        </bd-fa-button>
    </button>


    <app-actions-menu (menuItemClicked)="onActionsMenuItemClicked( $event )"
                      (mouseleave)="closeActionsMenu()" (mouseenter)="removeCloseMenuTimer()"
                      [menuItems]="actionMenuItems"
                      #actionMenu>

    </app-actions-menu>

    <!--    <div class="lock" *ngIf="project.isLocked">-->
    <!--        <span>Gesperrt</span>-->
    <!--    </div>-->

</div>
